// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './common/stylus/common.styl'
import router from './router'
import store from './store'
import { http } from './common/js/ajax'
import VueLazyload from 'vue-lazyload'
import vueTap from 'v-tap'
Vue.prototype.$http = http;
Promise.prototype.finally = function(callback){
    let P = this.constructor;
    return this.then(
      value  => P.resolve(callback()).then(() => value),
      reason => P.resolve(callback()).then(() => { throw reason })
    );
}
String.prototype.gblen = function() {    
    var len = 0;
    for (var i=0; i<this.length; i++) {    
        if (this.charCodeAt(i)>127 || this.charCodeAt(i)==94) {    
             len += 2;    
         } else {
             len ++;    
         }    
     }    
    return len;    
}
Vue.use(vueTap)
Vue.config.productionTip = false;
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: './images/book300.png',
  attempt: 1
})

new Vue({
    el: '#app',
    router,
    store,
    template: '<App />',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js